var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('t-modal-table-content', {
    ref: "addContentModalRef"
  }, [_c('div', {
    staticClass: "p-2 bg-white rounded-lg"
  }, [_c('div', {
    staticClass: "mb-4"
  }, [_c('h2', {
    staticClass: "text-xl font-bold text-gray-800"
  }, [_vm._v("Curated Content")])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isValidateItems,
      expression: "!isValidateItems"
    }],
    staticClass: "relative flex flex-col w-96 mb-4"
  }, [_c('div', {
    staticClass: "relative w-full"
  }, [_c('i', {
    staticClass: "fa-solid fa-magnifying-glass text-gray-400 text-base absolute top-3 left-3"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.searchQuery,
      expression: "searchQuery"
    }],
    staticClass: "hide-native-search p-2.5 pl-10 pr-10 w-full text-sm border rounded-lg focus:ring-blue-500 focus:border-blue-500",
    attrs: {
      "placeholder": "Search by Book Name or Content ID",
      "type": "search"
    },
    domProps: {
      "value": _vm.searchQuery
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value;
      }, _vm.onSearch],
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onSearch.apply(null, arguments);
      }
    }
  }), _vm.searchQuery ? _c('i', {
    staticClass: "fa-solid fa-xmark text-gray-400 text-base absolute top-3 right-3 cursor-pointer hover:text-gray-600",
    on: {
      "click": _vm.clearSearch
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "text-sm space-x-3 mt-3 font-medium flex justify-start items-center"
  }, [_c('div', [_vm._v(_vm._s(_vm.selectedItems.length) + " item(s) selected")]), _vm.selectedItems.length > 0 ? _c('Button', {
    attrs: {
      "variant": "outlined",
      "color": "alternative",
      "size": "xs"
    },
    on: {
      "click": function ($event) {
        _vm.selectedItems = [];
      }
    }
  }, [_vm._v(" Clear ")]) : _vm._e()], 1)]), _vm.isValidateItems ? _c('div', [_c('div', {
    staticClass: "relative w-96 mb-4"
  }, [_c('i', {
    staticClass: "fa-solid fa-magnifying-glass text-gray-400 text-base absolute top-3 left-3"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.searchValidationQuery,
      expression: "searchValidationQuery"
    }],
    staticClass: "hide-native-search p-2.5 pl-10 pr-10 w-full text-sm border rounded-lg focus:ring-blue-500 focus:border-blue-500",
    attrs: {
      "placeholder": "Search book name, type, or reason...",
      "type": "search"
    },
    domProps: {
      "value": _vm.searchValidationQuery
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.searchValidationQuery = $event.target.value;
      }, _vm.filterValidationSearch]
    }
  }), _vm.searchValidationQuery ? _c('i', {
    staticClass: "fa-solid fa-xmark text-gray-400 text-base absolute top-3 right-3 cursor-pointer hover:text-gray-600",
    on: {
      "click": _vm.clearValidationSearch
    }
  }) : _vm._e()]), !_vm.dataItems.is_valid ? _c('div', {
    staticClass: "bg-orange-50 p-2.5 rounded-lg mb-4 text-yellow-800 border-orange-200"
  }, [_c('label', {
    staticClass: "text-base font-semibold mb-1 flex items-center"
  }, [_c('i', {
    staticClass: "fa-solid fa-circle-info mr-2"
  }), _vm._v(" Confirmation Content ")]), _c('p', {
    staticClass: "text-sm mb-0"
  }, [_vm._v("Please review the content for the Onsite feature again. If there are any errors, you won't be able to save it. Make sure to correct them first.")])]) : _vm._e(), _c('div', {
    staticClass: "overflow-x-auto border rounded-lg height-custom overflow-y-auto"
  }, [_c('table', {
    staticClass: "min-w-full bg-white text-sm text-left"
  }, [_c('thead', {
    staticClass: "bg-gray-50 border-b sticky top-0 z-10"
  }, [_c('tr', [_c('th', {
    staticClass: "px-6 py-3 font-semibold text-gray-500 uppercase"
  }, [_vm._v("Image")]), _c('th', {
    staticClass: "px-6 py-3 font-semibold text-gray-500 uppercase"
  }, [_vm._v("Book name")]), _c('th', {
    staticClass: "px-6 py-3 font-semibold text-gray-500 uppercase"
  }, [_vm._v("Type")]), _c('th', {
    staticClass: "px-6 py-3 font-semibold text-gray-500 uppercase"
  }, [_vm._v("Status")]), _c('th', {
    staticClass: "px-6 py-3 font-semibold text-gray-500 uppercase"
  }, [_vm._v("Reason")])])]), _c('tbody', {
    staticClass: "divide-y divide-gray-200"
  }, [_vm._l(_vm.dataItems.data, function (item, index) {
    return _c('tr', {
      key: index,
      staticClass: "hover:bg-gray-50"
    }, [_c('td', {
      staticClass: "px-6 py-1 whitespace-nowrap text-sm text-gray-500"
    }, [item.thumb_image_normal ? _c('img', {
      staticClass: "h-10 w-10 object-cover rounded-none",
      attrs: {
        "src": 'https://ebooks.gramedia.com/ebook-covers/' + _vm.removeBucket(item.thumb_image_normal)
      }
    }) : _c('img', {
      staticClass: "h-10 w-10 object-cover rounded-none",
      attrs: {
        "src": _vm.DefaultImage,
        "alt": "empty thumb"
      }
    })]), _c('td', {
      staticClass: "px-6 py-1 whitespace-nowrap text-sm text-gray-700"
    }, [_vm._v(" " + _vm._s(item.name || '-') + " "), _c('p', [_vm._v("ID: " + _vm._s(item.id))])]), _c('td', {
      staticClass: "px-6 py-1 whitespace-nowrap text-sm text-gray-500 capitalize"
    }, [_vm._v(_vm._s(item.type || '-'))]), _c('td', {
      staticClass: "px-6 py-1 whitespace-nowrap text-sm text-gray-500 capitalize"
    }, [_c('span', {
      staticClass: "py-1 font-normal rounded-lg text-xs px-1.5",
      class: item.is_valid ? 'bg-blue-100 text-blue-800' : 'bg-red-100 text-red-800'
    }, [_vm._v(" " + _vm._s(item.is_valid ? 'Passed' : 'Failed') + " ")])]), _c('td', {
      staticClass: "px-6 py-1 w-full align-middle whitespace-normal text-sm text-gray-500 capitalize max-w-xs"
    }, [_c('p', {
      staticClass: "text-sm break-words mb-0"
    }, [_vm._v(" " + _vm._s(item.message || '') + " ")])])]);
  }), !_vm.dataItems.data || _vm.dataItems.data.length === 0 ? _c('tr', [_c('td', {
    staticClass: "px-6 py-6 text-center text-sm text-gray-500",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(" No data matches your search. ")])]) : _vm._e()], 2)])])]) : _c('div', [_c('div', {
    staticClass: "rounded-xl overflow-y-auto height-custom mb-4 border relative"
  }, [_c('table', {
    staticClass: "w-full text-sm text-left text-gray-500"
  }, [_c('thead', {
    staticClass: "text-xs text-gray-700 uppercase bg-gray-50 sticky top-0 z-10"
  }, [_c('tr', [_c('th', {
    staticClass: "p-3 w-4",
    attrs: {
      "scope": "col"
    }
  }), _c('th', {
    staticClass: "px-6 py-3",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("No")]), _c('th', {
    staticClass: "px-6 py-3",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Image")]), _c('th', {
    staticClass: "px-6 py-3",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Book Name")]), _c('th', {
    staticClass: "px-6 py-3",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Type")])])]), _c('tbody', {
    staticClass: "divide-y divide-gray-100"
  }, [_vm.isLoadingAvailableItems ? _c('tr', {
    staticClass: "inset-0 bg-white flex justify-center items-center z-10"
  }, [_c('td', {
    staticClass: "px-6 py-8 h-screen text-center text-gray-500",
    attrs: {
      "colspan": "5"
    }
  }, [_c('div', {
    staticClass: "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center"
  }, [_c('svg', {
    staticClass: "h-26 w-16 animate-spin text-blue-600 mb-4",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24"
    }
  }, [_c('circle', {
    staticClass: "opacity-25",
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 2 A 10 10 0 0 1 22 12",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  })])])])]) : _vm._e(), _vm._l(_vm.availableItems, function (item, index) {
    return _c('tr', {
      key: ((item.id) + "-" + index),
      staticClass: "bg-white hover:bg-gray-50"
    }, [_c('td', {
      staticClass: "p-3 w-4"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.selectedItems,
        expression: "selectedItems"
      }],
      staticClass: "w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 cursor-pointer",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(_vm.selectedItems) ? _vm._i(_vm.selectedItems, item.id) > -1 : _vm.selectedItems
      },
      on: {
        "change": function ($event) {
          var $$a = _vm.selectedItems,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedItems = $$a.concat([$$v]));
            } else {
              $$i > -1 && (_vm.selectedItems = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.selectedItems = $$c;
          }
        }
      }
    })]), _c('td', {
      staticClass: "px-6 py-2 font-medium text-gray-900"
    }, [_vm._v(" " + _vm._s((_vm.currentPage - 1) * _vm.limit + index + 1) + " ")]), _c('td', {
      staticClass: "px-6 py-2"
    }, [item.thumb_image_normal ? _c('img', {
      staticClass: "h-10 w-10 object-cover border",
      attrs: {
        "src": 'https://ebooks.gramedia.com/ebook-covers/' + _vm.removeBucket(item.thumb_image_normal),
        "alt": "thumb"
      }
    }) : _c('img', {
      staticClass: "h-10 w-10 object-cover border opacity-50",
      attrs: {
        "src": _vm.DefaultImage,
        "alt": "empty thumb"
      }
    })]), _c('td', {
      staticClass: "px-6 py-2 text-xs font-medium"
    }, [_vm._v(_vm._s(item.name))]), _c('td', {
      staticClass: "px-6 py-2 capitalize"
    }, [_vm._v(_vm._s(item.item_type || item.type))])]);
  }), _vm.availableItems.length === 0 && !_vm.isLoadingAvailableItems ? _c('tr', [_c('td', {
    staticClass: "px-6 py-8 text-center text-gray-500",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(" No data available. ")])]) : _vm._e()], 2)])]), _vm.totalAvailableItems / _vm.limit > 1 ? _c('div', {
    staticClass: "flex bg-white items-start justify-between ml-0 pt-0 align-middle px-0"
  }, [_c('div', {
    staticClass: "font-semibold mt-1"
  }, [_c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("Showing ")]), _vm._v(" " + _vm._s(_vm.currentPage) + "-" + _vm._s(_vm.limit) + " "), _c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("of")]), _vm._v(" " + _vm._s(parseInt(_vm.totalAvailableItems)) + " ")]), _c('div', {
    staticClass: "mb-2"
  }, [_c('t-pagination', {
    staticClass: "rounded-lg",
    attrs: {
      "total-items": Number(_vm.totalAvailableItems),
      "per-page": _vm.limit
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)]) : _vm._e()]), _c('div', {
    staticClass: "flex justify-start items-start space-x-3 align-middle"
  }, [!_vm.isValidateItems ? [_c('Button', {
    staticClass: "disabled:opacity-50",
    attrs: {
      "disabled": _vm.selectedItems.length === 0 || _vm.selectedItems.length > 100,
      "size": "sm"
    },
    on: {
      "click": _vm.onSelectionChange
    }
  }, [_vm._v(" Next ")]), _c('Button', {
    attrs: {
      "variant": "outlined",
      "color": "alternative",
      "size": "sm"
    },
    on: {
      "click": function ($event) {
        return _vm.$refs.addContentModalRef.hide();
      }
    }
  }, [_vm._v(" Back ")])] : [_vm.dataItems.is_valid ? _c('div', {
    staticClass: "space-y-5 space-x-3"
  }, [_c('Button', {
    staticClass: "disabled:opacity-50",
    attrs: {
      "size": "sm"
    },
    on: {
      "click": _vm.submitSelectedItems
    }
  }, [_vm._v(" Save ")]), _c('Button', {
    attrs: {
      "variant": "outlined",
      "color": "alternative",
      "size": "sm"
    },
    on: {
      "click": _vm.backToUpload
    }
  }, [_vm._v(" Back ")])], 1) : _c('div', [_c('Button', {
    staticClass: "mt-4 text-gray-700",
    attrs: {
      "variant": "outlined",
      "color": "alternative",
      "size": "xs"
    },
    on: {
      "click": _vm.backToUpload
    }
  }, [_vm._v(" Back to Choose Again ")])], 1)]], 2)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }